import { render, staticRenderFns } from "./ManagePatient.vue?vue&type=template&id=ecc7732c&scoped=true&"
import script from "./ManagePatient.vue?vue&type=script&lang=js&"
export * from "./ManagePatient.vue?vue&type=script&lang=js&"
import style0 from "./ManagePatient.vue?vue&type=style&index=0&id=ecc7732c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc7732c",
  null
  
)

export default component.exports